import * as React from 'react';
import { ForgotPassword } from 'aws-amplify-react';

import { PasswordRequirements } from './password-requirements';
import { renderStockScreen } from './stock-screen';
import { stripRequiredMarks } from './strip-required-marks';

/**
 * The stock Amplify v3 Reset Password screen with the password policy spelled
 * out on the second step, where the new password is actually chosen. The first
 * step only asks for the username, so nothing is added there.
 */
export class LabSmartsForgotPassword extends ForgotPassword {
  showComponent(theme: any): JSX.Element {
    return stripRequiredMarks(
      renderStockScreen(this, ForgotPassword, () => super.showComponent(theme)),
    ) as JSX.Element;
  }

  submitView(): JSX.Element {
    const view = super.submitView();
    if (!view || !view.props) {
      return view;
    }

    const fields = React.Children.toArray(view.props.children);
    return React.cloneElement(
      view,
      view.props,
      fields.concat(
        <PasswordRequirements className="ls-auth-field-note" key="ls-password-requirements" />,
      ),
    );
  }
}
